// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("flash")
require("address")
require("jquery")
require("@nathanvda/cocoon")
require("jquery-ui")
require("custom")
require("stripe")


import "../tags.js";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
//= require jquery3
//= require popper
//= require bootstrap

// header内のアイコンのポップアップスクリプト
$(document).on('click',function(e) {
  if ($(e.target).closest('#create-toggle1').length) {
    $('#popup-menu1').toggle();
    $('#popup-menu2').hide();
    $('#popup-menu3').hide();
    $('#popup-notice').hide();
  } else if ($(e.target).closest('#create-toggle2').length) {
    $('#popup-menu1').hide();
    $('#popup-menu2').toggle();
    $('#popup-menu3').hide();
    $('#popup-notice').hide();
  } else if ($(e.target).closest('#create-toggle3').length) {
    $('#popup-menu1').hide();
    $('#popup-menu2').hide();
    $('#popup-menu3').toggle();
    $('#popup-notice').hide();
  } else {
    $('#popup-menu1').hide();
    $('#popup-menu2').hide();
    $('#popup-menu3').hide();
  }
});